import { FormControlLabel, Radio } from "@mui/material";
import { useEffect, type FC } from "react";
import type { RadioButtonProps } from "../lib/type";

export const RadioButton: FC<RadioButtonProps> = ({
    label,
    hintIcon,
    checked,
    value,
    openHintArea,
    closeHintArea,
    toggleHintArea,
    icon,
    ...rest
}) => {
    useEffect(() => {
        if (hintIcon && openHintArea && closeHintArea) {
            checked ? openHintArea() : closeHintArea();
        }
    }, [checked]);

    return (
        <FormControlLabel
            control={<Radio checked={checked} value={value} {...rest} />}
            label={label}
        />
    );
};
